import Button from '@liquidweb-dev/undercurrent/Button';
import Popover, {
	type PopoverProps,
} from '@liquidweb-dev/undercurrent/Popover';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import useSecureDataShareExpire from 'modules/queries/secureDataShare/useExpire';
import Trash2Icon from '@liquidweb-dev/undercurrent/icons/lucide/Trash2';
import Typography from '@liquidweb-dev/undercurrent/Typography';

export interface PopoverDeleteNoteProps extends Omit<PopoverProps, 'onClose'> {
	datashareId: string | number;
	onClose: () => void;
}

const PopoverDeleteNote = ({
	datashareId,
	onClose,
	...popoverProps
}: PopoverDeleteNoteProps) => {
	const { mutate: expireSecureDataShare, isLoading: expireIsLoading } =
		useSecureDataShareExpire();

	const handleConfirm = () => {
		expireSecureDataShare(
			{ id: Number(datashareId) },
			{ onSuccess: () => onClose() },
		);
	};

	return (
		<Popover
			onClose={onClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			{...popoverProps}
		>
			<Stack sx={{ gap: 200 }}>
				<Typography variant="body-md">
					Are you sure you want to delete this note?{' '}
					<Typography sx={{ fontWeight: 500 }}>
						This cannot be undone.
					</Typography>
				</Typography>

				<Stack sx={{ flexDirection: 'row', gap: 100 }}>
					<Button variant="secondary" onClick={onClose} sx={{ flex: 1 }}>
						Cancel
					</Button>
					<Button
						color="danger"
						startIcon={<Trash2Icon />}
						onClick={handleConfirm}
						loading={expireIsLoading}
						sx={{ flex: 1 }}
					>
						Confirm
					</Button>
				</Stack>
			</Stack>
		</Popover>
	);
};

export default PopoverDeleteNote;
